'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
       value: true
});
exports.isObject = isObject;

var _2 = require('_');

var _3 = _interopRequireDefault(_2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// I hate javascript sometimes.
function isObject(obj) {
       return _3.default.isObject(obj) && !_3.default.isArray(obj) && !_3.default.isFunction(obj) && !_3.default.isDate(obj);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/utils/typeHelpers.js
// module id = 163
// module chunks = 0